import React from 'react';
import classNames from 'classnames';
import homeStore from '../stores/homeStore';
import Header from '../components/Header';
import ListItems from '../components/ListItems';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import { formatUpdatedAt } from '../helpers/formatters';

export default function Home() {
  const featured = homeStore((state) => state.featured);
  const coins = homeStore((state) => state.coins);
  const query = homeStore((state) => state.query);
  const loading = homeStore((state) => state.loading);
  const searching = homeStore((state) => state.searching);
  const searched = homeStore((state) => state.searched);
  const error = homeStore((state) => state.error);
  const searchError = homeStore((state) => state.searchError);
  const homeNotice = homeStore((state) => state.homeNotice);
  const searchNotice = homeStore((state) => state.searchNotice);
  const updatedAt = homeStore((state) => state.updatedAt);
  const setQuery = homeStore((state) => state.setQuery);
  const bootstrap = homeStore((state) => state.bootstrap);

  React.useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  return (
    <div className="page-shell" id="top">
      <Header />

      <main className="page-main">
        <Hero coins={featured} loading={loading && !featured.length} />

        <section className="search-section">
          <div className="width">
            <div className="section-heading">
              <p className="eyebrow">Search</p>
              <div className="section-heading__row">
                <div>
                  <h2>Look up any coin</h2>
                  <p>
                    Search requests are debounced and cached so the app can stay responsive while
                    putting less pressure on the market API.
                  </p>
                </div>
                <button type="button" className="ghost-button" onClick={bootstrap}>
                  Refresh market data
                </button>
              </div>
              {updatedAt && <small>Last refresh: {formatUpdatedAt(updatedAt)}</small>}
            </div>

            <div className={classNames('search-input', { searching })}>
              <svg className="search-input__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="20">
                <path
                  fill="currentColor"
                  d="M796-121 533-384q-30 26-69.959 40.5T378-329q-108.162 0-183.081-75Q120-479 120-585t75-181q75-75 181.5-75t181 75Q632-691 632-584.85 632-542 618-502q-14 40-42 75l264 262-44 44ZM377-389q81.25 0 138.125-57.5T572-585q0-81-56.875-138.5T377-781q-82.083 0-139.542 57.5Q180-666 180-585t57.458 138.5Q294.917-389 377-389Z"
                />
              </svg>

              <input
                type="text"
                value={query}
                onChange={setQuery}
                placeholder="Bitcoin, Solana, Ethereum..."
                aria-label="Search for a coin"
              />

              <svg className="search-input__spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20">
                <path
                  fill="currentColor"
                  d="M304 48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                />
              </svg>
            </div>

            {homeNotice && <div className="status-banner status-banner--info">{homeNotice}</div>}
            {searchNotice && <div className="status-banner status-banner--info">{searchNotice}</div>}
            {error && (
              <div className="status-banner status-banner--error">
                <span>{error}</span>
                <button type="button" className="ghost-button" onClick={bootstrap}>
                  Retry
                </button>
              </div>
            )}
            {searchError && <div className="status-banner status-banner--error">{searchError}</div>}
          </div>
        </section>

        <section className="coin-section">
          <div className="width">
            <div className="section-heading section-heading--tight">
              <p className="eyebrow">{searched ? 'Results' : 'Market watch'}</p>
              <h2>{searched ? 'Search results' : 'Top coins'}</h2>
            </div>

            <div className="coin-grid">
              {loading && !coins.length
                ? Array.from({ length: 6 }).map((_, index) => (
                    <div className="coin-card skeleton" key={index} aria-hidden="true" />
                  ))
                : coins.map((coin) => <ListItems key={coin.id} coin={coin} />)}
            </div>

            {!loading && !coins.length && (
              <div className="empty-state">
                <h3>No coins found.</h3>
                <p>Try a different name or clear the search to return to trending coins.</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
